module.exports = "/_next/static/media/43c45f27697d2294e07481cb3e269c13.svg";